import { SUSPEND_PREPAY_API } from 'constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(SUSPEND_PREPAY_API, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
